import React, { useCallback } from "react";
import { useLocale, useTracking, useTranslation } from "@edreamsodigeo/frontend-core";
import { Box, Button, Heading } from "@edreamsodigeo/prisma-design-system";
import { getHelpCenterUrl } from "../../../utils/helpCenter";
const ValuePropositionFooter = () => {
  const {
    t
  } = useTranslation();
  const {
    trackEvent
  } = useTracking();
  const locale = useLocale();
  const helpCenterLink = getHelpCenterUrl({
    locale
  });
  const onClickHelpCenter = useCallback(() => {
    trackEvent({
      category: "mytripslogin",
      action: "help_center",
      label: "click:help-center-link_pag:mytriplogin"
    });
    window.open(helpCenterLink, "_blank");
  }, [trackEvent, helpCenterLink]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    type: "6",
    color: "neutral.90"
  }, t("supportarea.mytripslogin.banner.footer.text.desktop.1")), /*#__PURE__*/React.createElement(Box, {
    mt: "small"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: onClickHelpCenter
  }, /*#__PURE__*/React.createElement(Heading, {
    type: "6"
  }, t("supportarea.mytripslogin.banner.footer.text.desktop.2")))));
};
export default ValuePropositionFooter;